import AutoFormStore from '../../redux/store';
import fetch from './httpFetch.service';
import { showMessage } from '../../utils/Message/redux/message.actions';
import { Method } from 'axios';

const makeRequests = (
  endpoint: string,
  method: Method,
  payload?: object,
  executeOnComplete?: Function,
  executeOnFail?: Function,
): void => {
  const dispatch = AutoFormStore.dispatch;

  const autoApi: string | undefined = process.env.REACT_APP_HOME_API_URL;
  fetch({
    params: {
      url: `${autoApi}/${endpoint}`,
      options: {
        method: method,
        data: JSON.stringify(payload),
      },
    },
    onComplete: response => {
      executeOnComplete && executeOnComplete(response);
    },
    onError: error => {
      const code = error.response ? error.response.status.toString() : '';
      const customCode = error.response ? error.response.data.code : '';
      dispatch(showMessage(code, customCode));
      executeOnFail && executeOnFail(error);
      try {
        throw new Error(
          `API error: ${error} with payload : ${JSON.stringify(payload)}`,
        );
      } catch (e) {
        console.error(e.name + ': ' + e.message);
      }
    },
  });
};

export default makeRequests;
